<script setup lang="ts">
import { LucideChevronDown } from 'lucide-vue-next'

interface IProps {
  align?: 'start' | 'end' | 'center'
  triggerName: string
}

const props = defineProps<IProps>()
</script>

<template>
  <DropdownMenu :modal="false">
    <DropdownMenuTrigger class="main-menu-item rounded-sm" as-child>
      <button>
        <slot name="icon" />
        {{ props.triggerName }}
        <LucideChevronDown class="icon size-4" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent :align="align || 'start'" class="mt-3">
      <div class="flex w-[500px] flex-col gap-4 p-4">
        <slot name="header" />
        <div class="grid grid-cols-2 gap-x-14 gap-y-3">
          <slot />
        </div>
        <slot name="footer" />
      </div>
      <slot name="banner" />
    </DropdownMenuContent>
  </DropdownMenu>
</template>
